export default __webpack_public_path__ + "static/media/PremiumCrownSparkles.3bf44ee6.svg";